<template>
  <div class="modal is-active">
    <div class="modal-background" @click="no"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ modal.title }}</p>
      </header>
      <div class="modal-card-body">
        <p>{{ modal.content }}</p>
      </div>
      <footer class="modal-card-foot">
        <button
          v-if="modal.type == 'notification'"
          class="button is-success"
          @click="proceed"
        >
          Ok
        </button>
        <button
          v-if="modal.type == 'okcancel'"
          class="button is-success"
          @click="yes"
        >
          Ok
        </button>
        <button
          v-if="modal.type == 'okcancel'"
          class="button is-warning"
          @click="no"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
import { inject, onMounted } from 'vue';
import { useStore } from 'vuex';
export default {
  props: ['modal'],
  setup(props) {
    const store = useStore();
    const emitter = inject('emitter');
    const no = () => {
      store.commit('modal/closeModal', props.modal.id);
      emitter.emit(props.modal.eventName + '-no');
    };
    const yes = () => {
      store.commit('modal/closeModal', props.modal.id);
      emitter.emit(props.modal.eventName + '-yes', props.modal.param);
    };
    const proceed = () => {
      store.commit('modal/closeModal', props.modal.id);
      emitter.emit(props.modal.eventName + '-proceed');
    };

    onMounted(() => {
      if (props.modal.type == 'autonotification') {
        setTimeout(() => {
          store.commit('modal/closeModal', props.modal.id);
        }, 1500);
      }
    });
    return { proceed, yes, no };
  },
};
</script>
<style lang="scss"></style>
